import React from "react";
import ContactUsTeam from "../../components/ContactUsTeam";
import ContactUsHeader from "../../components/ContactUsHeader";
import ContactUsForm from "../../components/ContactUsForm";

const ContactUs = () => {
  return (
    <div>
      <ContactUsHeader />
      <ContactUsTeam />
      <ContactUsForm />
    </div>
  );
};

export default ContactUs;
